import { clearActiveMenuItem, setActiveMenuItem, setupMenu, updateMenuRoot } from "../../../actions/menu";
import { getLoggedUser } from "../../../api/session";
import { getStoreMenu } from "../../../model/menu";
import EntityForm from "./entityForm"
import { isEmpty } from "../../../framework/utils";


export class StoreHeaderForm extends EntityForm {
    componentDidMount() {
        super.componentDidMount();
    
        const id = this.props.entityId;

        if (id) {
            updateMenuRoot({
                root: getStoreMenu(id)
            });

            setActiveMenuItem({id: "store.header"});
        }

    }

    onSubmit(data) {
        const storeId = this.props.entityId;
        if (isEmpty(storeId) || storeId === "new") {
            this.willGoBack = true;
        }
        super.onSubmit(data);
    }

    componentWillUnmount() {
        const user = getLoggedUser();
        super.componentWillUnmount();
        clearActiveMenuItem();
        setupMenu({user});
    }

}